import { c as _c } from "react/compiler-runtime";
import { DEFAULT_HOME_PATH } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Arrow, Button } from '@winelidays/wld-tsx-2/elements';
import { LArrowDirectionEnum } from '@winelidays/wld-tsx-2/types';
import { useNavigate } from 'react-router-dom';
const BackToListButton = t0 => {
    const $ = _c(12);
    const { className: t1 } = t0;
    const incomingClassName = t1 === undefined ? "" : t1;
    const navigate = useNavigate();
    const translate = useTranslate();
    let t2;
    if ($[0] !== translate) {
        t2 = translate("messages.back_to_list");
        $[0] = translate;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const title = t2;
    let t3;
    if ($[2] !== navigate) {
        t3 = () => {
            navigate(DEFAULT_HOME_PATH);
        };
        $[2] = navigate;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    const handleClick = t3;
    const className = `btn-outline-light inline-flex items-center self-center ${incomingClassName}`;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <span className="relative inline-flex w-2 h-4 mr-2"><Arrow direction={LArrowDirectionEnum.Left} className="border-current"/></span>;
        $[4] = t4;
    }
    else {
        t4 = $[4];
    }
    let t5;
    if ($[5] !== title) {
        t5 = <span>{title}</span>;
        $[5] = title;
        $[6] = t5;
    }
    else {
        t5 = $[6];
    }
    let t6;
    if ($[7] !== className || $[8] !== handleClick || $[9] !== t5 || $[10] !== title) {
        t6 = <Button title={title} onClick={handleClick} className={className}>{t4}{t5}</Button>;
        $[7] = className;
        $[8] = handleClick;
        $[9] = t5;
        $[10] = title;
        $[11] = t6;
    }
    else {
        t6 = $[11];
    }
    return t6;
};
export default BackToListButton;
